const $ = window.jQuery;

const AnimateOnPageLinks = {
	init() {
		$('a[href*="#"]:not([href="#"])').on('click', function () {
			const header = $('#header');
			const navHeight = header.find('nav.main').outerHeight();
			const adminBar = $('#wpadminbar');
			const adminBarHeight = adminBar.outerHeight();

			let offset = navHeight;
			if (adminBar.length) {
				offset = +navHeight + +adminBarHeight;
			}

			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
				location.hostname == this.hostname
			) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					$('html, body').animate(
						{
							scrollTop: target.offset().top - offset,
						},
						400
					);
					return false;
				}
			}
		});
	},
};

export default AnimateOnPageLinks;
